import { useEffect, useState } from "react";

/**
 * Global rolling ticker shown at the bottom of every screen.
 * Reads deviceKey from localStorage (same key the rest of the app uses)
 * and polls /api/ticker/active every 60s. If nothing is returned, the
 * bar hides itself — zero visual impact when there are no broadcasts.
 */
export default function TickerBar({ apiBase }) {
  const [messages, setMessages] = useState([]);
  const [deviceKey, setDeviceKey] = useState(
    typeof window !== "undefined"
      ? (localStorage.getItem("deviceKey") || localStorage.getItem("device_key") || "")
      : ""
  );

  // Re-read deviceKey from localStorage every 3s (it's set after /api/device/register resolves)
  useEffect(() => {
    const tid = setInterval(() => {
      const k = (localStorage.getItem("deviceKey") || localStorage.getItem("device_key") || "");
      if (k && k !== deviceKey) setDeviceKey(k);
    }, 3000);
    return () => clearInterval(tid);
  }, [deviceKey]);

  // Poll tickers every 60s once we have a key
  useEffect(() => {
    if (!deviceKey || !apiBase) return;
    let mounted = true;
    const fetchTickers = async () => {
      try {
        const r = await fetch(`${apiBase}/ticker/active?device_key=${encodeURIComponent(deviceKey)}`);
        if (!r.ok) return;
        const data = await r.json();
        if (!mounted) return;
        setMessages(Array.isArray(data) ? data.map(t => t.message).filter(Boolean) : []);
      } catch (e) { /* ignore */ }
    };
    fetchTickers();
    const tid = setInterval(fetchTickers, 60000);
    return () => { mounted = false; clearInterval(tid); };
  }, [deviceKey, apiBase]);

  if (!messages.length) return null;
  const track = messages.join("    •    ");
  return (
    <div
      data-testid="ticker-bar"
      style={{
        position: "fixed", bottom: 0, left: 0, right: 0, height: 32,
        background: "linear-gradient(90deg, rgba(20,184,166,0.95) 0%, rgba(14,165,233,0.95) 100%)",
        color: "#fff", overflow: "hidden", whiteSpace: "nowrap",
        fontSize: 14, fontWeight: 500, letterSpacing: "0.3px",
        boxShadow: "0 -2px 12px rgba(0,0,0,0.5)", zIndex: 9999,
        display: "flex", alignItems: "center", pointerEvents: "none",
      }}
    >
      <div
        style={{
          display: "inline-block", paddingLeft: "100%",
          animation: "nettv-ticker-scroll 45s linear infinite",
          willChange: "transform",
        }}
      >
        {track}&nbsp;&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;&nbsp;{track}
      </div>
      <style>{`
        @keyframes nettv-ticker-scroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
